import { render, staticRenderFns } from "./AllItemsList.vue?vue&type=template&id=5fa9bc38&scoped=true&"
import script from "./AllItemsList.vue?vue&type=script&lang=js&"
export * from "./AllItemsList.vue?vue&type=script&lang=js&"
import style0 from "./AllItemsList.vue?vue&type=style&index=0&id=5fa9bc38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa9bc38",
  null
  
)

export default component.exports